<template lang="pug">
	.display-object-props(v-if="showed" :style="{opacity: alpha, height: `calc(100% - ${Layout.headerHeight + Layout.subHeaderHeight}px)`, top: `${Layout.headerHeight + Layout.subHeaderHeight}px`, right: `${right}px`, zIndex: dragProcess ? 2000 : 2}")
		.cursor-container(v-if="dragProcess" :style="{cursor: ({x: 'ew-resize', y: 'ns-resize', 'xy': 'move'})[dragProcess.propertyModifier]}")
		.header-container(v-if="displayObject")
			.drag-header(v-if="getChangeProcess()")
				small.tutorial-text-header {{getChangeProcess().messages.dragProcess}}
				br
				small.tutorial-text-description(v-if="getChangeProcess().shiftKey && getChangeProcess().ctrlKey") {{getChangeProcess().messages.shiftCtrlOption}}
				small.tutorial-text-description(v-else-if="getChangeProcess().shiftKey") {{getChangeProcess().messages.shiftOption}}
				small.tutorial-text-description(v-else-if="getChangeProcess().ctrlKey") {{getChangeProcess().messages.ctrlOption}}
				small.tutorial-text-description.text-muted(v-else) {{getChangeProcess().messages.optionsProposal}}
			.default-header(v-else)
				.icon.fa(:class=`{
						'fa-folder': displayObject.type === 'container',
						'fa-picture-o': displayObject.type === 'sprite',
						'fa-font': displayObject.type === 'text',
						'fa-pencil': displayObject.type === 'graphics'
					}`)
				.name {{displayObject.codename}}
				.close-button(v-on:click="close")
					.fa.fa-close
		.props-container.main-props(v-if="displayObject")
			.prop-item(v-for="prop in props" v-if="prop.options['main']" :class="{'change-process': `${displayObject.codename}-${prop.codename}` in changedValues}")
				.title(v-b-tooltip.hover="{delay: {show: 1500, hide: 100 }, title: prop.description}") {{prop.title || prop.codename}}
				.control
					.control-dropdown-asset-image(v-if="prop.type === 'link' && prop.options.control === 'SelectorAssetImage'")
						DropdownAssetImage(:value="getDisplayedValue(prop)" v-on:change="changeValueByInput(prop, $event.assetCodename)")
					.control-dropdown-localization-text(v-if="prop.type === 'link' && prop.options.control === 'DropdownLocalizationText'")
						DropdownLocalizationText(:value="getDisplayedValue(prop)" v-on:change="changeValueByInput(prop, $event.textCodename)")
				.options
					.option.remove(v-on:click="removeProperty(prop)")
						.fa.fa-remove
					.option.portrait-landscape
		.props-container.typical-props(v-if="displayObject")
			.prop-item(v-for="prop in props" v-if="(prop.options['displayAlways'] || displayObject.props.hasOwnProperty(prop.codename)) && !prop.options['main']" :class="{'change-process': `${displayObject.codename}-${prop.codename}` in changedValues}")
				.title(v-b-tooltip.hover="{delay: { show: 1500, hide: 100 }, title: prop.description}") {{prop.title || prop.codename}}
				.control
					.control-point(v-if="prop.type === 'pixi-point'")
						.control-point-input
							label(v-on:wheel="processChangeValueByMouseWheel(prop, 'x', $event)")
								.label(:class="{active: isDisplayedValueChanged(prop, 'x')}" v-on:mousedown="startDrag(prop, 'x', $event)") x
								input.form-control.form-control-sm(:value="getDisplayedValue(prop, 'x')" v-on:keydown="startChangeValueByKeyPress(prop, 'x', $event)" v-on:keyup="changeValueByInput(prop, $event.target.value, 'x', $event, false)" v-on:change="changeValueByInput(prop, $event.target.value, 'x', $event)")
						.control-point-input
							label(v-on:wheel="processChangeValueByMouseWheel(prop, 'y', $event)")
								.label(:class="{active: isDisplayedValueChanged(prop, 'y')}" v-on:mousedown="startDrag(prop, 'y', $event)") y
								input.form-control.form-control-sm(:value="getDisplayedValue(prop, 'y')" v-on:keydown="startChangeValueByKeyPress(prop, 'y', $event)" v-on:keyup="changeValueByInput(prop, $event.target.value, 'y', $event, false)" v-on:change="changeValueByInput(prop, $event.target.value, 'y', $event)")
						.control-point-drag(:class="{active: dragProcess && dragProcess.propertyName === prop.codename && dragProcess.propertyModifier === 'xy'}")
							.fa.fa-arrows(v-on:mousedown="startDrag(prop, 'xy', $event)")
					.control-number(v-else-if="prop.type === 'number' && prop.options.control === 'range'")
						.number-input
							label(v-on:wheel="processChangeValueByMouseWheel(prop, null, $event)")
								input.form-control.form-control-sm(:value="getDisplayedValue(prop)" v-on:keydown="startChangeValueByKeyPress(prop, null, $event)" v-on:keyup="changeValueByInput(prop, $event.target.value, null, $event, false)" v-on:change="changeValueByInput(prop, $event.target.value, null, $event)")
						.range-input
							input.custom-range(type="range" :value="getDisplayedValue(prop)" :min="prop.options.controlOptions.min" :max="prop.options.controlOptions.max" :step="prop.options.controlOptions.step" v-on:input="changeValueByInput(prop, $event.target.value)")
					.control-number(v-else-if="prop.codename === 'angle'")
						.number-input
							label(v-on:wheel="processChangeValueByMouseWheel(prop, null, $event)")
								input.form-control.form-control-sm(:value="getDisplayedValue(prop)" v-on:keydown="startChangeValueByKeyPress(prop, null, $event)" v-on:keyup="changeValueByInput(prop, $event.target.value, null, $event, false)" v-on:change="changeValueByInput(prop, $event.target.value, null, $event)")
						.angle-input(:class="{active: rotateProcess && rotateProcess.propertyName === prop.codename, changed: getDisplayedValue(prop)}" v-on:mousedown="startRotation(prop, $event)")
							.angle-center(ref="angle-center")
							.angle-direction(:style="{transform: `rotate(${getDisplayedValue(prop)}deg)`}")
							.angle-default
					.control-number(v-else-if="prop.type === 'boolean'")
						.switch-control
							label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
								input.switch-input.form-check-input(type="checkbox" :checked="getDisplayedValue(prop)" v-on:change="changeValueByInput(prop, $event.target.checked, null, $event)")
								span.switch-slider(data-checked="On" data-unchecked="Off")
								span.switch-handle
				.options
					.option.remove(v-on:click="removeProperty(prop)")
						.fa.fa-remove
					.option.portrait-landscape
			.display-object-controls
				DropdownDisplayObjectProperty(:displayObject="displayObject" v-on:select="addProperty($event.propertyCodename)")
				DropdownDisplayObjectActions(:displayObject="displayObject")

</template>

<script>

	import Screen 							from './../../mixins/screen'

	import { DisplayObject }				from './../../services/DisplayObject'

	import DropdownAssetImage				from './../Controls/DropdownAssetImage'
	import DropdownDisplayObjectProperty	from './../Controls/DropdownDisplayObjectProperty'
	import DropdownDisplayObjectActions		from './../Controls/DropdownDisplayObjectActions'
	import DropdownLocalizationText			from './../Controls/DropdownLocalizationText'

	export default {
		name: 'DisplayObjectProps',
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Version Changed",
				"Selected Display Object Changed",
				"Selected Display Object Cleaned",
				"Settings Tab Changed",
				"Aside State Changed"
			],
			events: {
				"Sub Aside State Changed": function() {

					this.checkOpen();

				},
				"Selected Display Object Property Changed": function(displayObject, propertyCodename) {

					this.update();

					this.sendValueToIFrame(Metadata.DisplayObjectPropertiesByCodename[propertyCodename]);

				},
				"IFrame Data:DisplayObjectProperty": function(data) {

					if (data.displayObjectCodename === this.displayObject.codename) this.setValue(data.propertyName, data.propertyValue);

				},
				"IFrame Data:StartDisplayObjectDrag": function(displayObjectCodename) {

					if (displayObjectCodename === this.displayObject.codename) this.iFrameDragProcess = {messages: Metadata.DisplayObjectPropertiesByCodename['position'].options.messages}

				},
				"IFrame Data:DisplayObjectDrag": function(data) {

					if (this.iFrameDragProcess) {

						this.iFrameDragProcess.shiftKey = data.shiftKey;
						this.iFrameDragProcess.ctrlKey = data.ctrlKey;

						this.update();

					}

				},
				"IFrame Data:EndDisplayObjectDrag": function() {

					if (this.iFrameDragProcess) {

						this.iFrameDragProcess = null;

					}

				},
				"IFrame Data:StartDisplayObjectScale": function(displayObjectCodename) {

					if (displayObjectCodename === this.displayObject.codename) this.iFrameDragProcess = {messages: Metadata.DisplayObjectPropertiesByCodename['scale'].options.messagesIFrame}

				},
				"IFrame Data:DisplayObjectScale": function(data) {

					if (this.iFrameDragProcess) {

						this.iFrameDragProcess.shiftKey = data.shiftKey;
						this.iFrameDragProcess.ctrlKey = data.ctrlKey;

						this.update();

					}

				},
				"IFrame Data:EndDisplayObjectScale": function() {

					if (this.iFrameDragProcess) {

						this.iFrameDragProcess = null;

					}

				}
			}
		},
		components: {
			DropdownAssetImage,
			DropdownLocalizationText,
			DropdownDisplayObjectProperty,
			DropdownDisplayObjectActions
		},
		data() {

			this.displayObject = null;

			this.props = [];

			this.dragProcess = null;
			this.keyPressProcess = null;
			this.iFrameDragProcess = null;
			this.rotateProcess = null;

			return {
				showed: false,
				alpha: 0,
				right: 0,
				changedValues: {},
				deleteButtonHovering: false
			};

		},
		mounted() {

			window.addEventListener("mouseup", () => {

				if (this.dragProcess) this.stopDrag();
				if (this.rotateProcess) this.stopRotation();

			});

			window.addEventListener("mousemove", e => {

				if (this.dragProcess) this.processDrag(e);
				if (this.rotateProcess) this.processRotation(e);

			});

			window.addEventListener("keydown", e => {

				if (e.keyCode === 16) {

					if (this.keyPressProcess) this.keyPressProcess.shiftKey = true;
					if (this.dragProcess) this.dragProcess.shiftKey = true;
					if (this.rotateProcess) this.rotateProcess.shiftKey = true;

					this.update();

				}

				if (e.keyCode === 17) {

					if (this.keyPressProcess) this.keyPressProcess.ctrlKey = true;
					if (this.dragProcess) this.dragProcess.ctrlKey = true;
					if (this.rotateProcess) this.rotateProcess.ctrlKey = true;

					this.update();

				}

			});

			window.addEventListener("keyup", e => {

				if (this.keyPressProcess && (e.keyCode === 38 || e.keyCode === 40)) this.stopChangeValueByKeyPress();

				if (e.keyCode === 16) {

					if (this.keyPressProcess) this.keyPressProcess.shiftKey = false;
					if (this.dragProcess) this.dragProcess.shiftKey = false;
					if (this.rotateProcess) this.rotateProcess.shiftKey = false;

					this.update();

				}

				if (e.keyCode === 17) {

					if (this.keyPressProcess) this.keyPressProcess.ctrlKey = false;
					if (this.dragProcess) this.dragProcess.ctrlKey = false;
					if (this.rotateProcess) this.rotateProcess.ctrlKey = false;

					this.update();

				}

			});

		},
		methods: {
			checkOpen() {

				if (Layout.subAsideOpened) {

					if (!this.showed) {

						this.show();

						this.alpha = 0;
						this.right = 0;

						setTimeout(() => {
							this.alpha = 1;
							this.right = Layout.asideSize;
						}, 1);

					}

				}

				else {

					if (this.showed) {

						this.hide();

					}

				}

			},
			collectData() {

				this.displayObject = DisplayObject.SelectedDisplayObject;

				this.props = _.filter(_.orderBy(Metadata.DisplayObjectProperties, 'priority'), propertyParams => !propertyParams.options.displayObjectTypes || _.includes(propertyParams.options.displayObjectTypes, this.displayObject?.type));

			},
			getDisplayedValue(propertyParams, propertyModifier = null) {

				if (!this.displayObject) return null;

				let changedValueKey = `${this.displayObject.codename}-${propertyParams.codename}`;

				let value = null;

				if (changedValueKey in this.changedValues) value = this.changedValues[changedValueKey];
				else if (propertyParams.codename in this.displayObject.props) value = this.displayObject.props[propertyParams.codename];
				else value = '';

				if (propertyModifier === 'x') value = value[0];
				else if (propertyModifier === 'y') value = value[1];

				return value;

			},
			getValue(propertyParams, propertyModifier = null) {

				let changedValueKey = `${this.displayObject.codename}-${propertyParams.codename}`;

				let value = null;

				if (changedValueKey in this.changedValues) value = this.changedValues[changedValueKey];
				else if (this.displayObject.props[propertyParams.codename]) value = this.displayObject.props[propertyParams.codename];
				else return propertyParams.default;

				value = this.restoreValueType(propertyParams, value);

				if (propertyModifier === 'x') value = value[0];
				else if (propertyModifier === 'y') value = value[1];

				return value;

			},
			setValue(propertyName, propertyValue, fixAccuracy = true) {

				let propertyParams = _.find(this.props, propertyParams => propertyParams.codename === propertyName);

				let changedValueKey = `${this.displayObject.codename}-${propertyName}`;

				if (propertyParams.type === 'pixi-point') {

					if (fixAccuracy) this.changedValues[changedValueKey] = [propertyValue[0].toFixed(propertyParams.options.changes.accuracy), propertyValue[1].toFixed(propertyParams.options.changes.accuracy)];
					else this.changedValues[changedValueKey] = propertyValue;

				} else if (propertyParams.type === 'number') {

					if ("max" in propertyParams.options.changes)
						if (propertyValue > propertyParams.options.changes.max) propertyValue = propertyParams.options.changes.max;

					if ("min" in propertyParams.options.changes)
						if (propertyValue < propertyParams.options.changes.min) propertyValue = propertyParams.options.changes.min;

					if (fixAccuracy) this.changedValues[changedValueKey] = propertyValue.toFixed(propertyParams.options.changes.accuracy);
					else this.changedValues[changedValueKey] = propertyValue;

				} else if (propertyParams.type === 'boolean') {

					this.changedValues[changedValueKey] = !!propertyValue;

				} else {

					this.changedValues[changedValueKey] = propertyValue;

				}

				this.update();

				this.sendPropertyValueToServer(this.displayObject, propertyName, this.getValue(propertyParams));

			},
			restoreValueType(propertyParams, value) {

				if (propertyParams.type === 'pixi-point') value = [parseFloat(value[0]), parseFloat(value[1])];
				if (propertyParams.type === 'number') value = parseFloat(value);

				return value;

			},
			sendPropertyValueToServer(displayObject, propertyName, propertyValue) {

				let timeoutKey = `${displayObject['version_id']}-${displayObject['screen_codename']}-${displayObject['codename']}-${propertyName}`;

				displayObject.props[propertyName] = propertyValue;

				Server.sendWithTimeout({
					SetDisplayObjectProperty: {
						versionId: displayObject['version_id'],
						screenCodename: displayObject['screen_codename'],
						displayObjectCodename: displayObject['codename'],
						propertyName: propertyName,
						propertyValue: propertyValue
					}
				}, timeoutKey, 500, () => {

					delete this.changedValues[`${displayObject.codename}-${propertyName}`];

					this.update();

				});

			},
			isDisplayedValueChanged(propertyParams, propertyModifier) {

				let changedValueKey = `${this.displayObject.codename}-${propertyParams.codename}`;

				if (!(changedValueKey in this.changedValues)) return false;

				let changedValue = this.changedValues[changedValueKey];

				changedValue = this.restoreValueType(propertyParams, changedValue);

				if (propertyModifier === 'x') changedValue = changedValue[0];
				if (propertyModifier === 'y') changedValue = changedValue[1];

				let baseValue = propertyParams.default;
				if (this.displayObject.props[propertyParams.codename]) baseValue = this.displayObject.props[propertyParams.codename];

				baseValue = this.restoreValueType(propertyParams, baseValue);

				if (propertyModifier === 'x') baseValue = baseValue[0];
				if (propertyModifier === 'y') baseValue = baseValue[1];

				return JSON.stringify(changedValue) !== JSON.stringify(baseValue);

			},
			getChangeProcess() {

				return this.dragProcess || this.iFrameDragProcess || this.rotateProcess;

			},
			close() {

				DisplayObject.selectDisplayObject(null);

			},
			changeValueByInput(propertyParams, value, propertyModifier = null, e = null, isSave = true) {

				if (!e || (e.keyCode !== 38 && e.keyCode !== 40)) {

					let changedValueKey = `${this.displayObject.codename}-${propertyParams.codename}`;

					let propertyName = propertyParams.codename;

					if (propertyParams.type === 'pixi-point') {

						value = parseFloat(value);

						if (_.isNaN(value)) {

							value = undefined;

						} else {

							let newValue = this.getValue(propertyParams);

							newValue[propertyModifier === 'x' ? 0 : 1] = value;

							value = newValue;

						}

					} else if (propertyParams.type === 'number') {

						value = parseFloat(value);

						if (_.isNaN(value)) value = undefined;

					} else if (propertyParams.type === 'boolean') {

						value = !!value;

					}

					if (value !== undefined) {

						if (!(changedValueKey in this.changedValues)) this.changedValues[changedValueKey] = _.cloneDeep((propertyName in this.displayObject.props) ? this.displayObject.props[propertyName] : propertyParams.default);

						if (isSave) this.setValue(propertyParams.codename, value, false);

						this.sendValueToIFrame(propertyParams, value);

					}

				}

			},
			startChangeValueByKeyPress(propertyParams, propertyModifier, e) {

				let propertyName = propertyParams.codename;

				if (e.keyCode === 38 || e.keyCode === 40) {

					if (!this.keyPressProcess) {

						this.keyPressProcess = {
							propertyName: propertyName,
							propertyModifier: propertyModifier,
							propertyParams: propertyParams,
							increaser: e.keyCode === 40 ? -1 : 1,
							shiftKey: e.shiftKey
						};

						this.keyPressProcess.timeout = setTimeout(() => {

							this.changeValue(this.keyPressProcess.propertyParams, this.keyPressProcess.propertyModifier, this.keyPressProcess.increaser, this.keyPressProcess.shiftKey);

							this.keyPressProcess.interval = setInterval(() => {

								this.changeValue(this.keyPressProcess.propertyParams, this.keyPressProcess.propertyModifier, this.keyPressProcess.increaser, this.keyPressProcess.shiftKey);

							}, 50);

						}, 200);

						this.changeValue(this.keyPressProcess.propertyParams, this.keyPressProcess.propertyModifier, this.keyPressProcess.increaser, this.keyPressProcess.shiftKey);

					}

					e.preventDefault();

				}

			},
			stopChangeValueByKeyPress() {

				if (this.keyPressProcess) {

					clearTimeout(this.keyPressProcess.timeout);
					clearInterval(this.keyPressProcess.interval);
					clearTimeout(this.keyPressProcess.stopTimeout);

					this.keyPressProcess = null;

				}

			},
			processChangeValueByMouseWheel(propertyParams, propertyModifier, e) {

				this.changeValue(propertyParams, propertyModifier, Math.sign(e.wheelDelta), e.shiftKey);

			},
			startDrag(propertyParams, propertyModifier, e) {

				let propertyName = propertyParams.codename;

				this.dragProcess = {
					active: false,
					propertyName: propertyName,
					propertyModifier: propertyModifier,
					propertyParams: propertyParams,
					messages: propertyParams.options.messages,
					downPointerPosition: {
						x: e.clientX,
						y: e.clientY
					},
					downDisplayObjectPosition: this.getValue(Metadata.DisplayObjectPropertiesByCodename['position'], 'xy'),
					downDisplayObjectScale: this.getValue(Metadata.DisplayObjectPropertiesByCodename['scale'], 'xy'),
					downDisplayObjectSkew: this.getValue(Metadata.DisplayObjectPropertiesByCodename['skew'], 'xy'),
					downDisplayObjectPivot: this.getValue(Metadata.DisplayObjectPropertiesByCodename['pivot'], 'xy'),
					downDisplayObjectAnchor: this.getValue(Metadata.DisplayObjectPropertiesByCodename['anchor'], 'xy')
				};

				this.update();

			},
			processDrag(e) {

				if (this.dragProcess.active) {

					let offsetX = (e.clientX - this.dragProcess.downPointerPosition.x),
						offsetY = (e.clientY - this.dragProcess.downPointerPosition.y);

					if (this.dragProcess.propertyModifier === 'x') offsetY = 0;
					if (this.dragProcess.propertyModifier === 'y') offsetX = 0;

					if (this.dragProcess.propertyName === 'position') {

						// Если зажат shift (или по умолчанию нужно перемещать по прямым)
						// перемещаем по прямым и диагоналям относительно ТОЧКИ НАЧАЛА СМЕЩЕНИЯ
						if (e.shiftKey) {

							[offsetX, offsetY] = this.normalizeCoords(offsetX, offsetY, this.dragProcess.propertyParams)

						}

						let newX = this.dragProcess.downDisplayObjectPosition[0] + offsetX * this.dragProcess.propertyParams.options.changes.step[0],
							newY = this.dragProcess.downDisplayObjectPosition[1] + offsetY * this.dragProcess.propertyParams.options.changes.step[1];

						//Если зажат ctrl - перемещаем по прямым и диагоналям
						if (e.ctrlKey) {

							[newX, newY] = this.normalizeCoords(newX, newY, this.dragProcess.propertyParams);

						}

						this.setValue(this.dragProcess.propertyParams.codename, [newX, newY]);

					} else if (this.dragProcess.propertyName === 'scale') {

						let newValue = [this.dragProcess.downDisplayObjectScale[0], this.dragProcess.downDisplayObjectScale[1]];

						if (e.shiftKey) {

							let offset = Math.max(offsetX * this.dragProcess.propertyParams.options.changes.step[0], offsetY * this.dragProcess.propertyParams.options.changes.step[1]);
							let averageScale = (Math.abs(this.dragProcess.downDisplayObjectScale[0]) + Math.abs(this.dragProcess.downDisplayObjectScale[1])) / 2;
							let percent = offset / averageScale;

							newValue = [newValue[0] + newValue[0] * percent, newValue[1] + newValue[1] * percent];

						} else if (e.ctrlKey) {

							let offset = Math.max(offsetX * this.dragProcess.propertyParams.options.changes.step[0], offsetY * this.dragProcess.propertyParams.options.changes.step[1]);
							let averageScale = (Math.abs(this.dragProcess.downDisplayObjectScale[0]) + Math.abs(this.dragProcess.downDisplayObjectScale[1])) / 2;
							let percent = offset / averageScale;

							newValue = [averageScale + averageScale * percent, averageScale + averageScale * percent];

						} else {

							let newX = this.dragProcess.downDisplayObjectScale[0] + offsetX * this.dragProcess.propertyParams.options.changes.step[0],
								newY = this.dragProcess.downDisplayObjectScale[1] + offsetY * this.dragProcess.propertyParams.options.changes.step[1];

							newValue = [newX, newY];

						}

						this.setValue(this.dragProcess.propertyParams.codename, newValue);

					} else if (this.dragProcess.propertyName === 'skew') {

						let newX = this.dragProcess.downDisplayObjectSkew[0] + offsetX * this.dragProcess.propertyParams.options.changes.step[0],
							newY = this.dragProcess.downDisplayObjectSkew[1] + offsetY * this.dragProcess.propertyParams.options.changes.step[1];

						if (e.shiftKey && e.ctrlKey) {

							newX = Math.round(newX / (Math.PI / 2 / 20)) * (Math.PI / 2 / 20);
							newY = Math.round(newY / (Math.PI / 2 / 20)) * (Math.PI / 2 / 20);

						} else if (e.shiftKey) {

							newX = Math.round(newX / (Math.PI / 2 / 10)) * (Math.PI / 2 / 10);
							newY = Math.round(newY / (Math.PI / 2 / 10)) * (Math.PI / 2 / 10);

						} else if (e.ctrlKey) {

							newX = Math.round(newX / (Math.PI / 2 / 3)) * (Math.PI / 2 / 3);
							newY = Math.round(newY / (Math.PI / 2 / 3)) * (Math.PI / 2 / 3);

						}

						this.setValue(this.dragProcess.propertyParams.codename, [newX, newY]);

					} else if (this.dragProcess.propertyName === 'anchor') {

						let newX = this.dragProcess.downDisplayObjectAnchor[0] + offsetX * this.dragProcess.propertyParams.options.changes.step[0],
							newY = this.dragProcess.downDisplayObjectAnchor[1] + offsetY * this.dragProcess.propertyParams.options.changes.step[1];

						if (e.shiftKey && e.ctrlKey) {

							newX = Math.round(newX / 0.10) * 0.10;
							newY = Math.round(newY / 0.10) * 0.10;

						} else if (e.shiftKey) {

							newX = Math.round(newX / 0.50) * 0.50;
							newY = Math.round(newY / 0.50) * 0.50;

						} else if (e.ctrlKey) {

							newX = Math.round(newX / 0.25) * 0.25;
							newY = Math.round(newY / 0.25) * 0.25;

						}

						this.setValue(this.dragProcess.propertyParams.codename, [newX, newY]);

					} else if (this.dragProcess.propertyName === 'pivot') {

						let newX = this.dragProcess.downDisplayObjectPivot[0] + offsetX * this.dragProcess.propertyParams.options.changes.step[0],
							newY = this.dragProcess.downDisplayObjectPivot[1] + offsetY * this.dragProcess.propertyParams.options.changes.step[1];

						this.setValue(this.dragProcess.propertyParams.codename, [newX, newY]);

					}

					this.update();

					this.sendValueToIFrame(this.dragProcess.propertyParams);

				} else {

					let dx = e.clientX - this.dragProcess.downPointerPosition.x,
						dy = e.clientY - this.dragProcess.downPointerPosition.y;

					this.dragProcess.active = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2)) > 3;

				}

			},
			stopDrag() {

				this.dragProcess = null;

				this.update();

			},
			startRotation(propertyParams, e) {

				let propertyName = propertyParams.codename;

				let clientRect = this.$refs['angle-center'][0].getBoundingClientRect();

				this.rotateProcess = {
					active: true,
					propertyName: propertyName,
					propertyParams: propertyParams,
					messages: propertyParams.options.messages,
					downPointerPosition: {
						x: clientRect.x + clientRect.width / 2,
						y: clientRect.y + clientRect.height / 2
					},
					downDisplayObjectAngle: this.getValue(Metadata.DisplayObjectPropertiesByCodename['angle'])
				};

				this.processRotation(e);

			},
			processRotation(e) {

				if (this.rotateProcess.active) {

					let offsetX = (e.clientX - this.rotateProcess.downPointerPosition.x),
						offsetY = (e.clientY - this.rotateProcess.downPointerPosition.y);

					if (this.rotateProcess.propertyName === 'angle') {

						let angle = Math.atan(Math.abs(offsetY) / Math.abs(offsetX)) * 180 / Math.PI;

						if (offsetY >= 0 && offsetX <= 0) angle = 180 - angle;
						else if (offsetY <= 0 && offsetX <= 0) angle = 180 + angle;
						else if (offsetY <= 0 && offsetX >= 0) angle = 360 - angle;

						if (e.shiftKey && e.ctrlKey) {

							angle = Math.round(angle / 5) * 5;

						} else if (e.shiftKey) {

							angle = Math.round(angle / 45) * 45;

						} else if (e.ctrlKey) {

							angle = Math.round(angle / 15) * 15;

						}

						if (angle === 360) angle = 0;

						this.setValue(this.rotateProcess.propertyParams.codename, angle);

					}

					this.update();

					this.sendValueToIFrame(this.rotateProcess.propertyParams);

				} else {

					let dx = e.clientX - this.rotateProcess.downPointerPosition.x,
						dy = e.clientY - this.rotateProcess.downPointerPosition.y;

					this.rotateProcess.active = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2)) > 5;

				}

			},
			stopRotation() {

				this.rotateProcess = null;

			},
			changeValue(propertyParams, propertyModifier, increaser, shiftKey) {

				let changedValueKey = `${this.displayObject.codename}-${propertyParams.codename}`;

				let propertyName = propertyParams.codename;

				if (!(changedValueKey in this.changedValues)) this.changedValues[changedValueKey] = _.cloneDeep((propertyName in this.displayObject.props) ? this.displayObject.props[propertyName] : propertyParams.default);

				if (propertyParams.type === 'pixi-point') {

					let newValue = [parseFloat(this.changedValues[changedValueKey][0]), parseFloat(this.changedValues[changedValueKey][1])];

					newValue[propertyModifier === 'x' ? 0 : 1] += propertyParams.options.changes.step[propertyModifier === 'x' ? 0 : 1] * increaser * (shiftKey ? 10 : 1);

					this.setValue(propertyParams.codename, newValue);

				} else if (propertyParams.type === 'number') {

					let newValue = parseFloat(this.changedValues[changedValueKey]);

					newValue += propertyParams.options.changes.step * increaser * (shiftKey ? 10 : 1);

					this.setValue(propertyParams.codename, newValue);

				}

				this.sendValueToIFrame(propertyParams);

			},
			sendValueToIFrame(propertyParams, value = null) {

				Broadcast.call("Send To iFrame", [{
					DisplayObjectProperty: {
						screenCodename: this.displayObject['screen_codename'],
						displayObjectCodename: this.displayObject.codename,
						propertyName: propertyParams.codename,
						propertyValue: value !== null ? value : this.getValue(propertyParams)
					}
				}]);

			},
			normalizeCoords(x, y, propertyParams) {

				/*let xSign = Math.sign(x),
					ySign = Math.sign(y);*/

				if (propertyParams.options.snap.horizontal) {

					if (Math.abs(y) < propertyParams.options.snap.horizontal) y = 0;

				}

				if (propertyParams.options.snap.vertical) {

					if (Math.abs(x) < propertyParams.options.snap.vertical) x = 0;

				}

				/*if (propertyParams.options.snap.diagonal) {

					if (Math.abs(Math.abs(x) - Math.abs(y)) < propertyParams.options.snap.diagonal) {

						x = y = Math.min(Math.abs(x), Math.abs(y));
						x *= xSign; y *= ySign;

					}

				}*/

				if (propertyParams.options.snap.center) {

					if (Math.abs(x) < propertyParams.options.snap.center && Math.abs(y) < propertyParams.options.snap.center) {

						x = 0; y = 0;

					}

				}

				return [x, y];

			},
			addProperty(propertyCodename) {
				Server.sendToSocket({
					AddDisplayObjectProperty: {
						versionId: this.displayObject['version_id'],
						screenCodename: this.displayObject['screen_codename'],
						displayObjectCodename: this.displayObject['codename'],
						propertyName: propertyCodename
					}
				});
			},
			removeProperty(propertyParams) {

				/*Broadcast.call('Show Confirm', [{
					caption: propertyParams.options['displayAlways'] ? 'Clean display object property' : 'Remove display object property',
					message: propertyParams.options['displayAlways'] ? `Are you sure you want to clean display object property "${propertyParams.title}"?` : `Are you sure you want to remove display object property "${propertyParams.title}"? You will have possibility to add it again later.`,
					confirmButtonText: propertyParams.options['displayAlways'] ? '&nbsp;&nbsp;Clean property' : '&nbsp;&nbsp;Remove property',
					confirmButtonIcon: 'fa-remove',
					confirmCallback: () => {*/
						Server.sendToSocket({
							RemoveDisplayObjectProperty: {
								versionId: this.displayObject['version_id'],
								screenCodename: this.displayObject['screen_codename'],
								displayObjectCodename: this.displayObject['codename'],
								propertyName: propertyParams.codename
							}
						});
					/*}
				}]);*/

			}
		}

	}
</script>

<style lang="sass">

	.display-object-props
		position: absolute
		z-index: 2
		right: 0
		top: 0
		border-left: 1px solid #23282c
		width: 300px
		background-color: #343b41
		transition: opacity 0.25s, right 0.25s
		color: #f3f4f5

		.cursor-container
			position: fixed
			z-index: 2
			left: 0
			top: 0
			width: 100%
			height: 100%
			cursor: move

		.header-container
			display: flex
			flex-direction: row
			flex-wrap: nowrap
			align-items: center
			height: 46px
			padding: 5px
			border-bottom: 1px solid #23282c
			cursor: default

			.drag-header


			.default-header
				display: flex
				flex-direction: row
				flex-wrap: nowrap
				align-items: center
				justify-content: left
				width: 100%

				.icon
					padding: 5px
					opacity: 0.8

				.name
					padding: 5px

				.close-button
					padding: 5px
					margin-left: auto
					cursor: pointer
					opacity: 0.1

					&:hover
						color: #20a8d8
						opacity: 1

			.tutorial-text-header
				font-size: 12px
				color: var(--yellow)

			.tutorial-text-description
				color: var(--yellow)

		.props-container
			display: flex
			flex-direction: column

			.prop-item
				display: flex
				flex-direction: row
				flex-wrap: nowrap
				height: 31px
				border-bottom: 1px solid #2e3235
				padding-bottom: 1px

				.title
					display: flex
					align-items: center
					justify-content: left
					width: 100px
					color: #73818f
					font-size: 0.75rem
					padding-left: 0.5rem
					cursor: default
					user-select: none

				.control
					display: flex
					align-items: center
					justify-content: left
					width: 150px

					.control-point
						display: flex
						flex-direction: row
						flex-wrap: nowrap
						align-items: center
						justify-content: left

						.control-point-input
							display: flex
							flex-direction: row
							flex-wrap: nowrap
							border-radius: 0.1rem
							color: rgba(255, 255, 255, 0.87)
							background-color: rgba(255, 255, 255, 0.05)
							border: 1px solid rgba(255, 255, 255, 0.09)
							transition: border-color 0.35s ease-in-out, box-shadow 0.35s ease-in-out, color 0.35s ease-in-out
							overflow: hidden
							width: 60px
							height: 24px

							label
								display: flex
								flex-direction: row
								flex-wrap: nowrap
								margin: 0
								padding: 0

							.label
								display: flex
								justify-content: center
								width: 20px
								margin-top: -1px
								color: #73818f
								cursor: pointer
								user-select: none
								background-color: rgba(0, 0, 0, 0.05)
								border-right: 1px solid rgba(255, 255, 255, 0.05)

							input
								margin: 0
								width: 35px
								height: 100%
								box-shadow: none
								outline: none !important
								border-radius: 0
								border: none
								background-color: transparent
								padding: 0 3px

						.control-point-input:first-child
							border-top-right-radius: 0
							border-bottom-right-radius: 0

						.control-point-input:nth-child(2)
							border-top-left-radius: 0
							border-bottom-left-radius: 0
							margin-left: -1px
							border-left-color: rgba(255, 255, 255, 0)

						.control-point-input:focus-within
							border-color: rgba(255, 255, 255, 0.18)
							background-color: rgba(255, 255, 255, 0.10)
							color: rgba(255, 255, 255, 0.87)
							outline: none !important
							box-shadow: none

						.control-point-drag
							display: flex
							justify-content: center
							align-items: center
							width: 20px
							height: 20px
							border: 1px solid rgba(255, 255, 255, 0.09)
							background-color: rgba(255, 255, 255, 0.05)
							border-radius: 0.1rem
							cursor: pointer
							margin-left: 5px
							color: #73818f
							user-select: none

					.control-number
						display: flex
						flex-direction: row
						flex-wrap: nowrap
						align-items: center
						justify-content: left

						.number-input
							display: flex
							flex-direction: row
							flex-wrap: nowrap
							border-radius: 0.1rem
							color: rgba(255, 255, 255, 0.87)
							background-color: rgba(255, 255, 255, 0.05)
							border: 1px solid rgba(255, 255, 255, 0.09)
							transition: border-color 0.35s ease-in-out, box-shadow 0.35s ease-in-out, color 0.35s ease-in-out
							overflow: hidden
							width: 60px
							height: 24px

							label
								display: flex
								flex-direction: row
								flex-wrap: nowrap
								margin: 0
								padding: 0

							input
								margin: 0
								width: 58px
								height: 100%
								box-shadow: none
								outline: none !important
								border-radius: 0
								border: none
								background-color: transparent
								padding: 0 3px

						.range-input
							margin-left: 5px
							margin-top: 5px
							width: 78px
							cursor: pointer

							//.custom-range::-ms-track,
							.custom-range::-moz-range-track,
							.custom-range::-webkit-slider-runnable-track
								height: 3px
								background-color: rgba(255, 255, 255, 0.09)
								cursor: pointer

							//.custom-range::-ms-thumb,
							.custom-range::-moz-range-thumb,
							.custom-range::-webkit-slider-thumb
								width: 10px
								height: 10px
								background-color: #383d47
								border: 1px solid rgba(255, 255, 255, 0.09)
								cursor: pointer
								box-shadow: none

						.angle-input
							position: relative
							width: 24px
							height: 24px
							border-radius: 24px
							background-color: rgba(255, 255, 255, 0.05)
							border: 1px solid rgba(255, 255, 255, 0.09)
							margin-left: 5px
							cursor: pointer
							user-select: none

							.angle-center
								position: absolute
								left: 9px
								top: 9px
								width: 2px
								height: 2px
								border-radius: 2px
								background-color: rgba(255, 255, 255, 0.09)
								border: 2px solid rgba(255, 255, 255, 0.09)

								&.changed
									border: 2px solid #383d47

							.angle-direction
								position: absolute
								left: 13px
								top: 10px
								width: 9px
								height: 0
								border: 1px solid #383d47
								transform-origin: -2px center
								transform: rotate(0deg)
								display: none

							.angle-default
								position: absolute
								left: 13px
								top: 10px
								width: 9px
								height: 0
								border-top: 2px solid rgba(255, 255, 255, 0.04)

							&.changed

								.angle-center
									border-color: #2d3139

								.angle-direction
									border-color: #2d3139
									display: block

							&.active
								border-color: #20a8d8

								.angle-center
									border-color: #20a8d8

								.angle-direction
									border-color: #20a8d8

						.switch-control
							margin-top: 5px

							.switch-label.switch-sm
								width: 38px
								height: 20px

								.switch-slider
									background-color: rgba(255, 255, 255, 0.09)
									border-color: rgba(255, 255, 255, 0.05)

								.switch-slider::before
									width: 14px
									height: 14px
									border-radius: 12px
									top: 2px
									left: 2px
									border-color: rgba(255, 255, 255, 0.05)
									background-color: rgba(255, 255, 255, 0.09)

							.switch-success .switch-input:checked + .switch-slider::before
								background-color: rgba(255, 255, 255, 0.5)

				.options
					display: flex
					flex-direction: row
					flex-wrap: nowrap
					align-items: center
					justify-content: right
					width: 45px

					.option
						width: 15px
						height: 15px
						border: 1px solid rgba(255, 255, 255, 0.09)
						background-color: rgba(255, 255, 255, 0.05)
						border-radius: 0.1rem
						cursor: pointer
						margin-right: 2px

						&.remove
							border: none
							background: transparent
							font-size: 11px
							position: relative

							.fa
								position: absolute
								left: 2px
								top: 2px
								color: rgba(255, 255, 255, 0.05)

							&:hover

								.fa
									color: #20a8d8

			.prop-item.change-process

				.title
					color: #20a8d8

				.control

					.control-point

						.control-point-input

							.label.active
								color: #20a8d8
								font-weight: bold

						.control-point-drag.active
							color: #20a8d8
							border-color: #20a8d8

					.control-number

						.range-input

							//.custom-range::-ms-track,
							.custom-range::-moz-range-track,
							.custom-range::-webkit-slider-runnable-track
								border: 1px solid #20a8d8
								background-color: rgba(255, 255, 255, 0.09)

							//.custom-range::-ms-thumb,
							.custom-range::-moz-range-thumb,
							.custom-range::-webkit-slider-thumb
								background-color: #383d47
								border: 1px solid #20a8d8

			.display-object-controls
				display: flex
				flex-direction: row
				justify-content: left
				padding-top: 10px
				border-top: 2px solid #2e3235

				.dropdown-display-object-property
					margin-left: 5px

				.dropdown-display-object-actions
					margin-left: auto
					margin-right: 5px

		.props-container.main-props
			border-bottom: 2px solid #2e3235

		.tmp

</style>
